"use client";

import { NavbarClient } from "@/layout/global/navbar/Navbar.client";

/** Site chrome nav for `(public)` pages. Not mounted on `(home)` (`/`). */
export function PublicHeaderChrome() {
	return (
		<header className="relative z-10 border-b border-secondary bg-primary">
			<NavbarClient />
		</header>
	);
}
